import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel, {
  ValueChangedEvent,
} from "../../../../../widgets/SearchPanel";
import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnButton from "@shared/components/SnButton";
import SnTab from "@shared/components/SnTab";
import SnTabHeader from "@shared/components/SnTabHeader";
import { showDialog } from "@widgets/CommonDialog";
import SnFileHelper from "@shared/components/SnFileHelper";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_PRD_BAS_REG_025 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region Variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
  });
  const SharedFormref1 = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const fileHelperRef = useRef<any>(null);
  const { userInfo } = global();
  //#endregion

  //#region Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const selectedTabPage = useRef<string>("1");
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setSharedForm(rtn.form.freeform1);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region Button Events
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));
  //#endregion

  //#region onSearch
  const onSearch = async () => {
    const modifiedRows = gridRefs.current["grid1"].current?.getChange();
    const modifiedRows2 = gridRefs.current["grid2"].current?.getChange();
    const modifiedRows3 = gridRefs.current["grid3"].current?.getChange();

    if (
      modifiedRows?.modifiedRowcount > 0 ||
      modifiedRows2?.modifiedRowcount > 0 ||
      modifiedRows3?.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirmCancel",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );

      if (confirm) {
        await onSave();
      } else if (confirm === undefined) {
        //취소 크릭할 때 그냥 리턴
        return;
      }
    }
    try {
      const params = {
        id: "sn_prd_bas_reg_025_01",
        params: searchRef.current.getFormdata(),
      };

      setFocusedRowData(null);

      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0] || [],
        grid2: data[1] || [],
        grid3: data[2] || [],
      });

      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      gridRefs.current["grid3"].current?.resetUpdate();
    } catch (error: any) {}
  };
  //#endregion

  //#region onInsert
  const onInsert = () => {
    gridRefs.current["grid1"].current.addRow();
  };
  //#endregion

  //#region onBeforeAddRow1
  const onBeforeAddRow1 = (): boolean | Record<string, any> => {
    try {
      const searchInfo = searchRef.current.getFormdata();
      const updateRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: searchInfo.cd_biz,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        cd_dept: userInfo.cd_dept,
        nm_dept: userInfo.nm_dept,
        st_use: "001",
        st_mfp: "P",
        cd_exch: "000",
      };

      return updateRow;
    } catch (error: any) {
      return false;
    }
  };
  //#endregion

  //#region onAddRow
  const onAddRow = async () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();

      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      if (selectedTabPage.current === "1") {
        gridRefs.current["grid2"].current.addRow();
      } else {
        gridRefs.current["grid3"].current.addRow();
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region onDeleteRow
  const onDeleteRow = async () => {
    if (selectedTabPage.current === "1") {
      if (gridRefs.current["grid2"].current?.getDisplayedRowCount() < 1) return;
      gridRefs.current["grid2"].current?.deleteSelectedRows();
    } else {
      if (gridRefs.current["grid3"].current?.getDisplayedRowCount() < 1) return;
      gridRefs.current["grid3"].current?.deleteSelectedRows();
    }
  };
  //#endregion

  //#region onBeforeAddRow2
  const onBeforeAddRow2 = () => {
    try {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const updateRow = {
        cd_firm: userInfo.cd_firm,
        no_tool: focusedNodeH.data?.no_tool,
      };

      return updateRow;
    } catch (error: any) {
      return false;
    }
  };
  //#endregion

  //#region onBeforeAddRow3
  const onBeforeAddRow3 = () => {
    try {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();

      const updateRow = {
        cd_firm: userInfo.cd_firm,
        no_tool: focusedNodeH.data?.no_tool,
        yn_inv: "Y",
      };

      return updateRow;
    } catch (error: any) {
      return false;
    }
  };
  //#endregion

  //#region onDelete
  const onDelete = async () => {
    try {
      if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

      const confirm = await showDialog("confirm", "삭제하시겠습니까?");
      if (!confirm) return;

      gridRefs.current["grid3"].current.deleteAllRows();
      gridRefs.current["grid2"].current.deleteAllRows();
      gridRefs.current["grid1"].current.deleteSelectedRows();

      const realDeletedRows =
        gridRefs.current["grid1"].current.getChange().delete ?? [];
      if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
        gridRefs.current["grid3"].current.resetUpdate();
        return;
      }

      return await onSave();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region onSave
  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current.stopEditing();
      gridRefs.current["grid2"].current.stopEditing();
      gridRefs.current["grid3"].current.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) return false;

      const requiredValuesCheckD =
        gridRefs.current["grid3"].current.requiredValuesCheck();
      if (!requiredValuesCheckD) return false;

      const tool = gridRefs.current["grid1"].current.getChange();
      const tool_item = gridRefs.current["grid2"].current.getChange();
      const tool_sn = gridRefs.current["grid3"].current.getChange();

      if (
        tool.modifiedRowcount === 0 &&
        tool_item.modifiedRowcount === 0 &&
        tool_sn.modifiedRowcount === 0
      ) {
        await showDialog("alter", "저장할 내용이 없습니다.");
        return false;
      }
      const saveData = {
        tool: tool,
        tool_item: tool_item,
        tool_sn: tool_sn,
      };
      const ok = await fnSave("SN_PRD_BAS_REG_025_SAVE_01", saveData);
      if (!ok) return false;

      gridRefs.current["grid3"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid1"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid3"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      gridRefs.current["grid1"].current.resetUpdate(true);
      return false;
    }
  };
  //#endregion

  //#region onTabChanged
  const onTabChanged = (tabIndex: any) => {
    setIsVisible(!isVisible);
    selectedTabPage.current = tabIndex;
  };
  //#endregion

  //#region onGrid2BtnsClick
  const onGrid2BtnsClick = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    } else if (id === "deleteRow") {
      onDeleteRow();
    }
  };
  //#endregion

  //#region onGrid3BtnsClick
  const onGrid3BtnsClick = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    } else if (id === "deleteRow") {
      onDeleteRow();
    }
  };
  //#endregion

  //#region onFocusedRowChanged
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
      const selectedRow = focusedRowData;

      if (selectedRow) {
        const no_tool = selectedRow.no_tool;
        gridRefs.current["grid2"].current?.applyFilters({ no_tool: no_tool });
        gridRefs.current["grid2"].current.selectAndFocusRow(0);
        gridRefs.current["grid3"].current.applyFilters({ no_tool: no_tool });
        gridRefs.current["grid3"].current.selectAndFocusRow(0);
      } else {
        return;
      }
    },
    [focusedRowData]
  );
  //#endregion

  //region handleFileUploadSuccess
  const handleFileUploadSuccess = async (
    fileName: string,
    isUpload: boolean
  ) => {
    const focusedNodes =
      gridRefs.current["grid1"].current.api.getSelectedNodes();
    if (focusedNodes.length === 0) {
      await showDialog("alter", "먼저 행을 선택하세요.");
      return;
    }

    const focusedRowNode = focusedNodes[0];
    if (focusedRowNode) {
      focusedRowNode.setDataValue("dc_url_pic", fileName);
    }
  };
  //#endregion

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onBeforeAddRow: onBeforeAddRow1,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onBeforeAddRow: onBeforeAddRow2,
          onBtnAddClick: onGrid2BtnsClick,
          onBtnDeleteClick: onGrid2BtnsClick,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onBtnAddClick: onGrid3BtnsClick,
          onBtnDeleteClick: onGrid3BtnsClick,
          onBeforeAddRow: onBeforeAddRow3,
        },
      },
    }),
    [columns, dataSources]
  );

  //#region UI
  return (
    <div className="h-full flex flex-col overflow-hidden">
      {/* 검색영역 */}
      <div className="mb-1 shrink-0">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>

      {/* 메인영역 */}
      <div className="flex-1 flex min-h-0 gap-1.5">
        {/* 좌측 Grid1 */}
        <div className="w-[40%] min-w-0 h-full">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "치공구정보",
            }}
            events={grids.grid1.events}
            filter={{
              refs: [gridRefs.current["grid2"], gridRefs.current["grid3"]],
              columns: ["no_tool"],
            }}
          />
        </div>

        {/* 우측영역 */}
        <div className="flex-1 flex flex-col min-h-0 gap-1.5">
          {/* 우측 상단 상세폼 */}
          <div className="h-[65%] min-h-0 overflow-hidden">
            <SharedForm
              ref={SharedFormref1}
              data={focusedRowData}
              controls={sharedForm}
              gridref={gridRefs.current["grid1"]}
              title="상세정보"
            />
          </div>

          {/* 파일업로드 */}
          <div className="shrink-0">
            <SnFileHelper
              ref={fileHelperRef}
              onFileUploadSuccess={handleFileUploadSuccess}
              accept="image/*"
            />
          </div>

          {/* 우측 하단 탭 */}
          <div className="flex-1 min-h-0">
            <SnTab
              titles={["품목정보", "TOOL_SN"]}
              width="100%"
              onTabChanged={onTabChanged}
              header={[
                <SnTabHeader
                  onBtnAddClick={onGrid2BtnsClick}
                  onBtnDeleteClick={onGrid2BtnsClick}
                />,
                <SnTabHeader
                  onBtnAddClick={onGrid3BtnsClick}
                  onBtnDeleteClick={onGrid3BtnsClick}
                />,
              ]}
              body={[
                <SnGrid
                  ref={gridRefs.current["grid2"]}
                  columnConfig={grids.grid2.columns}
                  rowData={grids.grid2.dataSource}
                  etcProps={{
                    rowSelection: "single",
                  }}
                  events={grids.grid2.events}
                />,

                <SnGrid
                  ref={gridRefs.current["grid3"]}
                  columnConfig={grids.grid3.columns}
                  rowData={grids.grid3.dataSource}
                  etcProps={{
                    rowSelection: "single",
                  }}
                  events={grids.grid3.events}
                />,
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_BAS_REG_025;
